module.exports = __webpack_public_path__ + "img/Christoph Rabl.fc67869d.jpg";